// navigation titles specific to zh-CN
export default {
  'tabbar.i18n': '多语言',
  'i18n.title': '中文标题',

  'test': '测试',
};
